import Label from "components/general/Label";
import { useMemo } from "react";
import MirsTable from "components/general/table/Table";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const MarksInfo = ({data}) => {

    const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()

    const marks = data?.results?.extendedInfos?.filter(ei => ei?.ei_code === 'MARK')?.sort((a, b) => a?.ei_pos - b?.ei_pos);
    const headers = marks?.map(m => ({value: m?.ei_value, pos: m?.ei_pos}));
    
    const mirsData = [
        {
            header: 'HeaderWindDir',
            code: 'WIND_DIRECTION',
            order: 1
        },
        {
            header: 'HeaderWindSpeed',
            code: 'WIND_SPEED',
            order: 2
        },
        {   header: 'HeaderElapsedTime',
            code: 'TIME',
            order: 3
        }
    ]

    function marksInfoColumns(marks, headers) {
        return [
            {
                id: 'MarkHeaders',
                accessor: 'order',
                Header: <Label data={'HeaderMarks'} />,
                headerClassName: "text-start w-10",
                className: 'text-start',
                Cell: (props) => {
                    const res = props.cell.row.original
                    return (<><Label data={res?.header} />:</>)
                }
            },
            ...getColumnsMark(marks, headers)
        ]
    }

    function getColumnsMark(marks, headers) {
        return headers?.map(h => (
                {
                    id: 'Mark' + h?.pos,
                    Header: h?.value === 'S' ? <Label data={'HeaderStart'} /> :  h?.value === 'F' ? <Label data={'HeaderFinish'} /> : h?.value,
                    headerClassName: "text-end",
                    className: 'text-end w-5',
                    Cell: (props) => {                       
                        const mark = marks?.find(m => m?.ei_pos === h?.pos)
                        const row = props.cell.row.original
                        const value = mark?.extensions?.find(e => e?.eie_code === row?.code)?.eie_value                        
                        return (<>{value}</>);
                    }
                }
            ));
    }
    
    const columns = useMemo(() => marksInfoColumns(marks, headers), []);

    return (
          <MirsTable
            id={`mirs-table-race-info-${mirs_rsc}`}
            data={mirsData}
            columns={columns}
            keyRow={"code"}
            initialSortBy={[{ id: 'MarkHeaders', desc: false }]}
          />
      );
    
}

export default MarksInfo;